(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map", [], factory);
	else if(typeof exports === 'object')
		exports["map"] = factory();
	else
		root["map"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 